import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Icon from 'components/Icon'

import './extended-input.pcss'

const ExtendedInput = ({
    icon,
    iconProps = {},
    unitsTip,
    button,
    size,
    children,
    className,
}) => {
    return (
        <div
            className={classNames(
                'extended-input',
                size ? `extended-input--size-${size}` : '',
                { 'extended-input--has-icon': !!icon },
                className,
            )}
        >
            {icon && (
                <div className="extended-input__icon-container">
                    <Icon
                        fa
                        name={icon}
                        color="#b1b1b1"
                        size="s"
                        {...iconProps}
                    />
                </div>
            )}
            {children}
            {unitsTip && (
                <div className="extended-input__units-tip-container">
                    <span className="extended-input__units-tip">
                        {unitsTip}
                    </span>
                </div>
            )}
            {button && (
                <div className="extended-input__button-container">
                    <span className="extended-input__button">
                        {button}
                    </span>
                </div>
            )}
        </div>
    )
}

ExtendedInput.propTypes = {
    className: PropTypes.string,
    icon: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.string,
    ]),
    iconProps: PropTypes.object,
    unitsTip: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
    ]),
    button: PropTypes.node,
}

export default ExtendedInput
